import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CHOREOGRAPHY_RETURN_PATH, completeChoreographyAuthorization } from '../../services/choreographyAuth';

export default function ChoreographyAuthCallback() {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    completeChoreographyAuthorization(window.location.search)
      .then((returnPath) => navigate(returnPath, { replace: true }))
      .catch((issue) => setError(issue?.message || 'Choreography sign-in failed.'));
  }, [navigate]);

  if (error) return <div className="choreography-shell"><p role="alert">{error}</p><button type="button" onClick={() => navigate(CHOREOGRAPHY_RETURN_PATH, { replace: true })}>Restart Choreography sign-in</button></div>;
  return <div className="choreography-shell"><p>Completing Choreography sign-in…</p></div>;
}
